import {init as initAxios} from '@/helpers/axios/index';
import authRepository from '@/helpers/api/authRepository/auth';  
import simulationRepository from '@/helpers/api/simulationRepository/simulation';
import comparingRepository from '@/helpers/api/comparingRepository/comparing';
import favoritesRepository from '@/helpers/api/favoritesRepository/favorites';
import calendarRepository from '@/helpers/api/calendarRepository/calendar';
import chartRepository from '@/helpers/api/chartRepository/chart';

import Vue from 'vue'; 

export default { 
    repositories: init()
} 

function inject(key, data, object) { 
    Object.defineProperty(object, key, {
        get () {
          return data;
        },
        set(v) {  
            return data = v;
        }
    });
};

function appendToVue(repositories) {
    inject('$api', repositories,  Vue.prototype);
};
 
function init() {  
    const axios = initAxios();
   
    const auth = authRepository(axios);
    const simulation = simulationRepository(axios);
    const comparing = comparingRepository(axios);
    const favorites = favoritesRepository(axios);
    const calendar = calendarRepository(axios);
    const charts = chartRepository(axios);

    const repositories = {
        auth,
        simulation,
        comparing,
        favorites,
        calendar,
        charts
    };

    appendToVue(repositories);

    return repositories;
};
